import { createGlobalStyle } from "styled-components";
import BREAKPOINTS from "../constants/breakpoints";

const oneRemInPixels = 16;

const bpInRem = (bp) => {
  return BREAKPOINTS[bp] / oneRemInPixels + "rem";
};

// const color = "#b3d9ff";

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }
  
  html, body {
    margin: 0;
    padding: 0;
    height: 100vh;
  }
  
  html {
    font-size: 100%;
  }
  
  body {
    background: ${(props) => props.theme.colors.main};
    font-family: ${(props) => props.theme.fonts.main.family};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: ${(props) => props.theme.fonts.main.size};
    image-rendering: pixelated;
    overscroll-behavior: none;
    // transition: all 0.1s linear;
    width: 100%;
  }
  
  #root{
    color: ${(props) => props.theme.colors.second};
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  a {
    color: inherit;
  }
  
  a:hover, a:visited {
    color: inherit;
  }
  
  table {
    border-spacing: 0;
    color: black;
    background-color: white;
  }
    
  th,
  td {
    margin: 0;
    padding: 0.25rem 0.5rem;
    text-align: center;
  } 
  
  th.left, td.left {
    text-align: left;
  }
  
  th.right, td.right {
    text-align: right;
  }
  
  tbody tr:nth-child(even){
    background-color: #e6f2ff;
  }
  
  table a, li a {
    text-decoration: none;
  }
  
  table a:hover, table a:active, li a:hover, li a:active{
    text-decoration: underline;
  }
  
  table tr:hover td{
    background-color: #B3D9FF;
  }
  
  table.no-stripes {
    & tr {
      background-color: white;
    }
  
    & tbody tr:nth-child(odd){
      background-color: white;
    }
  }
  
  table.no-hover {
    & tr:hover td{
      background-color: none;
    }
  }
  
  table.standard {
    background: white;
    color: black;
    width: 100%;
    border-spacing: 0;
    border: 2px solid white;
  
    & tbody tr.selected td {
      background-color: #80c1ff;
    }
  
    & tbody tr:nth-child(odd){
      background-color: #e6f2ff;
    }
  
    & td {
      padding: 0.1rem;
    }
  }

  td.center {
    text-align: center;
  }
  
  .content{
    flex: 1 0 auto;
    width: 100%;
  }
  
  footer{
    flex-shrink: 0;
  }
  
  .footer-content{
    width: 100%;
  }
  
  main{
    max-width: 100%;
    padding: 0.5rem;
  }
  
  nav a, nav a:hover, nav a:active {
    text-decoration: none;
  }
  
  ul.flex {
    align-items: center;
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  
  li.flex-sm {
    flex: 0 1 0;
  }
  
  li.flex-lg {
    flex: 1 0 0;
  }
  
  li.dropdown{
    position: relative;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }
  
  ul.dropdown-content{
    display: none;
    position: absolute;
    z-index: 103;
    white-space: nowrap;
    background: inherit;
    margin-top: 0.25rem;
    box-shadow: 0 2.5px 5px ${(props) => props.theme.colors.boxShadow};
    left: 0;
    right: auto;
    padding-top: 0.25rem;
  }
  
  li.dropdown:hover > ul.dropdown-content{
    display: block;
  }
  
  ul.dropdown-content.right{
    left: auto;
    right: 0;
    margin-right: 0.25rem;
  }
  
  li.submenu{
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }
  
  ul.flex.submenu-content{
    margin-top: 0.5rem;
    overflow: hidden;
    transition: max-height 0.2s ease;
  }
  
  ul.flex.submenu-content > li{
    padding-left: 0.5rem;
  }
  
  ul.flex.submenu-content.closed{
    max-height: 0;
  }
  
  ul.flex.submenu-content.open{
    max-height: 10rem;
  }
  
  .modal__overlay--container{
    display: none;
    position: absolute;
    left: 0;
    height: 100%;
    top: 0;
    width: 100%;
  }
  
  .modal__overlay--color{
    height: 100vh;
    width: 100vw;
    background: black;
    opacity: 0.5;
    border: 2px solid black;
  }
  
  nav{
    //font-family: "Press Start 2P", "Arial", sans-serif;
    //font-size: 0.75rem;
    //text-transform: uppercase;
  }
  
  nav a {
    display: block;
    padding: 0.5rem 0.5rem;
  }
  
  form {
    padding: 0;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-flow: column wrap;
    justify-content: flex-start;
  }
  
  form label, form button, button {
    font-family: "Press Start 2P", "Arial", sans-serif;
    font-size: 0.5625rem;
    text-transform: uppercase;
    padding: 0.5rem;
    border: none;
    border-radius: 0.5rem;
  }
  
  button a, button a:hover {
    text-decoration: none;
  }
  
  .form-group {
    margin-bottom: 0.5rem;
  }
  
  textarea {
    width: 100%;
    height: 8rem;
    margin: 0.5rem 0 0;
  }
  
  .btn {
    padding: 0.5rem;
    background: ${(props) => props.theme.colors.second};
    color: ${(props) => props.theme.colors.main};
    border-color: ${(props) => props.theme.colors.main};
    margin: 0.25rem 0;
    text-transform: uppercase;
    width: fit-content;
    border-radius: 0.5rem;
    border-style: solid;
    height: 1.875rem;
    cursor: pointer;
  }
  
  .btn-primary {
  }
  
  .btn-secondary {
    background: #3B9AFF;
    color: white;
    border-color: white;
  }
  
  .btn[disabled]{
    opacity: 0.5;
  }
  
  .btn-secondary.btn-right {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: 0;
  }
  
  .btn-cancel {
    background: white;
    color: #666;
    border-color: #666;
  }
  
  .btn-alert {
    color: #fff;
    background: ${(props) => props.theme.colors.danger};
    border: none;
  }
  
  form label{
    display: block;
  }
  
  input {
    margin: 0.5rem 0 1rem;
    padding: 0.25rem;
    width: 100%;
    max-width: 16rem;
  }
  
  input[type=checkbox]{
    width: auto;
  }
  
  input.left {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  
  input.err {
    border: 3px solid ${(props) => props.theme.colors.danger};
    margin-bottom: 0;
  }
  
  .alert{
    color: #fff;
    background: ${(props) => props.theme.colors.danger};
    padding: 0.25rem;
    margin-bottom: 1rem;
  }
  
  .err {
    max-width: 16rem;
  }
  
  
  .pagination-container {
    display: flex;
    list-style-type: none;
    margin: 0.5rem auto;
    padding: 0;
  
    .pagination-item {
      padding: 0 12px;
      height: 32px;
      text-align: center;
      margin: auto 4px;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      letter-spacing: 0.01071em;
      border-radius: 16px;
      line-height: 1.43;
      font-size: 13px;
      min-width: 32px;
      opacity: 0.75;
  
      &.dots:hover {
        background-color: transparent;
        cursor: default;
      }
      &:hover {
        background-color: rgba(128, 255, 255, 0.4);
        cursor: pointer;
      }
  
      &.selected {
        background-color: rgba(0, 255, 255, 0.4);
      }
  
      .arrow {
        &::before {
          position: relative;
          /* top: 3pt; Uncomment this to lower the icons as requested in comments*/
          content: '';
          /* By using an em scale, the arrows will size with the font */
          display: inline-block;
          width: 0.4em;
          height: 0.4em;
          border-right-width: 0.12em;
          border-top-width: 0.12em;
          border-right-style: solid;
          border-top-style: solid;
          border-color: inherit;
        }
  
        &.left {
          transform: rotate(-135deg) translate(-50%);
        }
  
        &.right {
          transform: rotate(45deg);
        }
      }
  
      &.disabled {
        pointer-events: none;
  
        .arrow::before {
          border-right: 0.12em solid rgba(255, 255, 255, 0.43);
          border-top: 0.12em solid rgba(255, 255, 255, 0.43);
        }
  
        &:hover {
          background-color: transparent;
          cursor: default;
        }
      }
    }
  }  
  
  @media (min-width: ${bpInRem("sm")}){
    form {
      padding-left: 1rem;
      width: 100%;
    }
    
    input {
      margin: 0.5rem 0;
      padding: 0.25rem;
      width: 16rem;
    }
  }
  
  @media (min-width: ${bpInRem("md")}){    
    main{
      max-width: ${bpInRem("lg")};
    }
    
    .footer-content{
      max-width: ${bpInRem("lg")};
    }
  }
  
  `;

export default GlobalStyle;
